var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',[_c('van-col',{attrs:{"span":"24"}},[(_vm.showNav)?_c('t-navbar',{scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("navbar-right")]},proxy:true}],null,true)}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }